export default {
    state: {
        isOpened: true,
        isRightSideBarOpened: false,
    },

    getters: {
        sidebarIsOpened: (state) => {
            return state.isOpened
        },
        isRightSideBarOpened: state => state.isRightSideBarOpened
    },

    mutations: {
        setChangeSidebarState(state) {
            state.isOpened = !state.isOpened
            localStorage.setItem('leftSidebar.state', JSON.stringify(state.isOpened))
        },
        toggleRightSideBarVisibility(state) {
            state.isRightSideBarOpened = !state.isRightSideBarOpened
        },
        setSidebarState(state, payload) {
            state.isOpened = payload
        }
    },

    actions: {
        getChangeSidebarState({commit}) {
            commit('setChangeSidebarState')
        },
        setSidebarState({commit}, payload) {
            commit('setSidebarState', payload)
        }
    },
}
